import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <center>
      <h2>{`Welcome to my online portfolio!`}</h2>
      <p>{`Hi there! I am Alfonso Jimenez, a SW developer mainly interested in PHP and JavaScript. Please feel free to explore my projects
and get to know me!`}</p>
      <img src="https://alfonso-jim.github.io/img/phpjs.png" style={{
        "display": "inline-block",
        "maxWidth": "25%",
        "borderRadius": "8px",
        "marginLeft": "auto",
        "marginRight": "auto"
      }} />
    </center>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      